 <!-- error-503 start-->
 <div class="error-wrapper">
     <div class="container">
         <img class="img-100" src="assets/images/other-images/sad.png" alt="Sad icon">
         <div class="error-heading">
             <h2 class="font-secondary">Erreur de création de profil</h2>
         </div>
         <div class="col-md-8 offset-md-2">
             <p class="sub-content">La création de votre profil a échoué. Veuillez réessayer dans quelques instants.</p>
             <p class="sub-content">Si le problème persiste, veuillez contacter le service informatique en indiquant le message d'erreur suivant :</p>
         </div>
         <div>
             <a class="btn btn-secondary-gradien btn-lg" (click)="back()">Réessayer</a>
<!--             <a class="btn btn-secondary-gradien btn-lg" href="mailto:support@yourcompany.com">Contacter le support</a>-->
         </div>
     </div>
 </div>

  <!-- error-503 end-->
